import ActiveSessionsDialog from "./ActiveSessionsDialog";

export default ActiveSessionsDialog;